var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report"},[_c('EditReport',{attrs:{"reportId":_vm.pageId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }